import * as styles from "./details-needed-banner.module.css";

type DetailsNeededBannerProps = {
	missingDetails: readonly string[];
};

export const DetailsNeededBanner = ({
	missingDetails,
}: Readonly<DetailsNeededBannerProps>) => {
	if (missingDetails.length === 0) return null;

	return (
		<div
			className={styles.detailsNeededBanner}
			data-testid={"details-needed-banner"}
			role={"alert"}
		>
			<p className={styles.detailsNeededTitle}>Details Needed</p>
			<p className={styles.detailsNeededDescription}>
				This shipment was bulk uploaded and cannot be tendered until the
				following {missingDetails.length === 1 ? "detail is" : "details are"}{" "}
				provided:
			</p>
			<ul className={styles.detailsNeededList}>
				{missingDetails.map((detail) => (
					<li key={detail}>{detail}</li>
				))}
			</ul>
		</div>
	);
};
